<!-- Logged in -->
<ng-container *ngIf="isLoggedIn && isStaffOrAdmin">
    <div class="d-flex flex-column gap-3">
        <app-news-list [excludeRead]="true"></app-news-list>

        <!-- AssignmentSchedules -->
        <ng-container
            *ngIf="assignmentScheduleStateService.unansweredAssignmentSchedulesSubject | async as assignmentSchedules">
            <ng-container *ngIf="assignmentSchedules?.length">
                <app-page-divider [text]="'assignmentSchedules.unanswered.title' | transloco"
                    [icon]="'fa-calendar-users fa-solid'"></app-page-divider>

                <app-assignment-schedules-list [assignmentSchedules]="assignmentSchedules">
                </app-assignment-schedules-list>
            </ng-container>
        </ng-container>

        <!-- Upcoming Assignments -->
        <app-page-divider [text]="'home.upcomingAssignments.title' | transloco"
            [icon]="'fa-solid fa-calendar-days'"></app-page-divider>
        <app-assignments-list [assignmentSubject]="assignmentsStateService.topThreeUpcomingAssignmentSubjects"
            [eventType]="assignmentEventTypes.RouteToDetails"></app-assignments-list>
        <div class="d-flex justify-content-center">
            <button [routerLink]="'/assignments/my'" class="btn btn-default">
                {{ "home.showMore.title" | transloco }}
            </button>
        </div>

        <!-- Open Assignments -->
        <app-page-divider [text]="'home.openAssignments.title' | transloco"
            [icon]="'fa-solid fa-calendar-days'"></app-page-divider>
        <app-assignments-list [assignmentSubject]="assignmentsStateService.topThreeOpenAssignmentSubjects"
            [eventType]="assignmentEventTypes.CustomAction"
            (clicked$)="openAssignmentClicked($event)"></app-assignments-list>
        <div class="d-flex justify-content-center">
            <button [routerLink]="'/assignments/open'" class="btn btn-default">
                {{ "home.showMore.title" | transloco }}
            </button>
        </div>

    </div>
</ng-container>

<!-- Not logged in -->
<ng-container *ngIf="isLoggedIn != undefined && !isLoggedIn">
    <div class="d-flex flex-column gap-md-5 gap-3 p-3" style="min-height: 100%;">
        <div class="">
            <div class="d-flex flex-column justify-content-center align-items-center bg-primary rounded p-md-5 p-3">
                <h1 class="h1 text-grey-1">{{ 'home.loginWelcome' | transloco }}</h1>
            </div>
        </div>

        <div class="flex-grow-1 d-flex justify-content-center">
            <div class="col-12 col-md-5">
                <div class="d-flex flex-column gap-2">
                    <button class="btn btn-primary text-bold fs-4 w-100" (click)="login(false)">
                        {{ 'home.singleLogin' | transloco }}
                    </button>
                    <button class="btn btn-default text-bold fs-4 w-100" (click)="login(true)">
                        {{ 'home.rememberLogin' | transloco }}
                    </button>
                </div>
            </div>
        </div>
        <div class="pb-3">
            <app-sponsors></app-sponsors>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="isLoggedIn && !isStaffOrAdmin">

    <div class="d-flex flex-column gap-3">

        <div class="alert alert-warning">
            {{'home.unauthorized' | transloco}}
        </div>

        <div class="flex-grow-1 d-flex justify-content-center">
            <div class="col-12 col-md-5">
                <button class="btn btn-primary text-bold fs-4 w-100" (click)="logout()">
                    {{ 'home.logout' | transloco }}
                </button>
            </div>
        </div>
    </div>
</ng-container>